import ContentContainer from "layout/Content/ContentContainer";
import { ReactComponent as IconNotification } from "assets/images/icons/notifications-sharp.svg";
import TitleWithIcon from "components/ui/TitleWithIcon/TitleWithIcon";
import useData from "hooks/useData";
import Alert from "components/ui/Alert/Alert";
import { useEffect, useState } from "react";
import Loader from "components/ui/Loader/Loader";
import { useLocation } from "react-router-dom";

function PageUnsubscribe() {
  const { postData } = useData();
  const location = useLocation();

  const [ isLoading, setIsLoading ] = useState(true);
  const [ alert, setAlert ] = useState();

  const handleUnsubscribe = async () => {
    const urlParams = new URLSearchParams(location.search);
    const uid = urlParams.get('uid');
    const section = urlParams.get('section');
    const token = urlParams.get('token');

    setIsLoading(true);
    const result = await postData('rest/notification/unsubscribe', {
      uid: uid,
      section: section,
      token: token,
    });

    if (result?.status === 200) {
      setAlert(<Alert message={ 'Uw afmelding is succesvol verwerkt, u ontvangt voortaan geen meldingen meer van ons voor dit onderdeel.' } type={ 'success' }/>);
    } else {
      setAlert(<Alert message={ 'Het afmelden is niet gelukt, probeer het opnieuw of neem contact op met de helpdesk als het probleem blijft bestaan.' } type={ 'error' }/>);
    }

    setIsLoading(false);
  }

  useEffect(() => {
      handleUnsubscribe();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
   [ location.search ]
  );

  return (
    <ContentContainer contentBackground={ true }
                      contentPadding={ true }
                      contentGridType={ 'small' }
                      containerPadding={ true }>
      <TitleWithIcon title={ `Afmelden notificaties` } hasBottomMargin={ true }>
        <IconNotification/>
      </TitleWithIcon>
      { isLoading && <Loader /> }
      { alert }
    </ContentContainer>
  );
}

export default PageUnsubscribe;
